import { __awaiter, __extends, __generator } from "tslib";
// DS: C16A, C16B
/** A collapsable, lazy loaded editor specifically configured for comment posting */
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import ddt from '@wix/da-ddt';
import { withLogBiEvent, } from '../biLogger/hocs/withLogBiEvent';
import { BiEventType } from '../biLogger';
import UserAvatar from '../User/Avatar';
import ElementQueries from '../ElementQueries';
import DisabledOrPrivateInfo from './_partials/DisabledOrPrivateInfo';
import CommentBoxEditor from './_partials/CommentBoxEditor.comment_redesign_b';
// Merge the text theme with the editor theme (content vs editor toolbars etc)
import CommentForAnonymous from '../CommentForAnonymous';
import { withVerification, } from '../VerificationPopup/withVerification';
import { InView } from 'react-intersection-observer';
import { compose } from 'redux';
import noop from '../utils/noop';
import s from './CommentBox.comment_redesign_b.scss';
import { withMobileContext } from '../Context';
var CommentBox = /** @class */ (function (_super) {
    __extends(CommentBox, _super);
    function CommentBox(props) {
        var _this = _super.call(this, props) || this;
        _this.postComment = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, id, isBusy, editComment, replyComment, commentableType, commentableItemId, isVerificationNeeded, draftState, removeEditorDraft, pushVerificationPopup, onPublishComment, logBiEvent;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.props, id = _a.id, isBusy = _a.isBusy, editComment = _a.editComment, replyComment = _a.replyComment, commentableType = _a.commentableType, commentableItemId = _a.commentableItemId, isVerificationNeeded = _a.isVerificationNeeded, draftState = _a.draftState, removeEditorDraft = _a.removeEditorDraft, pushVerificationPopup = _a.pushVerificationPopup, onPublishComment = _a.onPublishComment, logBiEvent = _a.logBiEvent;
                        if (isBusy) {
                            return [2 /*return*/];
                        }
                        if (isVerificationNeeded) {
                            pushVerificationPopup('comment');
                            return [2 /*return*/];
                        }
                        // Clean up draft state in local storage
                        if (draftState) {
                            removeEditorDraft(id);
                        }
                        if (!this.state.isEdit) {
                            logBiEvent({
                                evid: BiEventType.COMMENT_BUTTON_CLICK,
                                itemid: typeof commentableItemId === 'string'
                                    ? parseInt(commentableItemId)
                                    : commentableItemId,
                                typeid: commentableType,
                                is_reply: replyComment ? 1 : 0,
                            });
                        }
                        return [4 /*yield*/, this.editorApi.resolveEditorStateForAndroid()];
                    case 1:
                        _e.sent();
                        onPublishComment({
                            editorId: id,
                            typeId: commentableType,
                            itemId: commentableItemId,
                            rawContentState: (_b = this.editorState) === null || _b === void 0 ? void 0 : _b.rawContentState,
                            editorContent: (_c = this.editorState) === null || _c === void 0 ? void 0 : _c.editorContent,
                            featuresData: (_d = this.editorState) === null || _d === void 0 ? void 0 : _d.features,
                            editComment: editComment,
                            replyComment: replyComment,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.expand = function () {
            var _a = _this.props, logBiEvent = _a.logBiEvent, commentableItemId = _a.commentableItemId, commentableType = _a.commentableType;
            logBiEvent({
                evid: BiEventType.CLICK_ON_COMMENTS_TO_START_TYPING,
                itemid: typeof commentableItemId === 'string'
                    ? parseInt(commentableItemId)
                    : commentableItemId,
                typeid: commentableType,
            });
            _this.setState({
                loadingState: 2 /* DONE */,
                isExpanded: true,
            });
        };
        _this.collapse = function () {
            var _a, _b;
            var isEmpty = (_b = (_a = _this.editorState) === null || _a === void 0 ? void 0 : _a.isEmpty) !== null && _b !== void 0 ? _b : true;
            if (!_this.state.isEdit && isEmpty) {
                _this.setState({ isExpanded: false });
            }
        };
        _this.cancel = function () {
            var _a, _b;
            var _c = _this.props, t = _c.t, id = _c.id, draftState = _c.draftState, removeEditorDraft = _c.removeEditorDraft, onClose = _c.onClose;
            var isEmpty = (_b = (_a = _this.editorState) === null || _a === void 0 ? void 0 : _a.isEmpty) !== null && _b !== void 0 ? _b : true;
            // Clean up draft state in local storage
            if (draftState) {
                removeEditorDraft(id);
            }
            if (!_this.state.isEdit && !isEmpty) {
                var cancel = confirm(t('commentbox.editor.cancel.confirm'));
                if (!cancel) {
                    return;
                }
                _this.editorApi.clearEditor(true);
            }
            _this.setState({ isExpanded: false });
            onClose && onClose();
        };
        _this.handleBeforeUnload = function (e) {
            var _a, _b;
            var _c = _this.props, isLoggingOut = _c.isLoggingOut, saveEditorDraft = _c.saveEditorDraft, removeEditorDraft = _c.removeEditorDraft, draftState = _c.draftState;
            var isEmpty = (_b = (_a = _this.editorState) === null || _a === void 0 ? void 0 : _a.isEmpty) !== null && _b !== void 0 ? _b : true;
            if (isLoggingOut) {
                // On logout we have a specific saga that clears all drafts
                return;
            }
            else if (!isEmpty) {
                saveEditorDraft(_this.props.id, _this.editorState);
            }
            else if (draftState) {
                removeEditorDraft(_this.props.id);
            }
        };
        _this.handleEditorReady = function (toolbars, api) {
            var _a = _this.props, id = _a.id, focus = _a.focus, focusDone = _a.focusDone, onEditorReady = _a.onEditorReady;
            _this.editorApi = api;
            if (focus) {
                _this.setState({ focusOnMount: true }); // Need to force loadable to load
                focusDone(id);
            }
            api.focusEditor(); // auto focus the editor because we always use lazyload and that will steal the click
            onEditorReady && onEditorReady();
        };
        _this.handleEditorChange = function (editorState) {
            _this.editorState = editorState;
        };
        _this.handlePlaceholderClick = function () {
            _this.setState({ loadingState: 1 /* LOADING */ });
        };
        _this.onViewChange = function (inView) {
            // This is here is handle animations that scroll to the editor
            var _a = _this.props, focus = _a.focus, autoFocus = _a.autoFocus;
            var focusOnMount = _this.state.focusOnMount;
            var shouldFocus = focus !== false || focusOnMount;
            if (!_this.editorApi) {
                return;
            }
            if (autoFocus || (inView && shouldFocus)) {
                ddt.log('comments', 'Focusing CommentBox editor in InView.onChange, id: ', _this.props.id);
                _this.editorApi.focusEditor();
            }
        };
        var isEdit = props.editComment ? true : false;
        _this.state = {
            isEdit: isEdit,
            isExpanded: isEdit || props.initiallyExpanded || props.focus,
            focusOnMount: false,
            loadingState: 0 /* UNLOADED */,
        };
        if (props.draftState) {
            _this.initialContent = props.draftState;
        }
        else if (isEdit) {
            _this.initialContent = props.editComment.textContent;
        }
        return _this;
    }
    CommentBox.prototype.componentDidMount = function () {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    };
    CommentBox.prototype.componentWillUnmount = function () {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    };
    // TODO remove this its deprecated
    CommentBox.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps.publishResult) {
            if (this.editorApi && !this.state.isEdit) {
                this.editorApi.clearEditor(true);
                setTimeout(function () { return _this.editorApi.blurEditor(); }, 100);
            }
            this.setState({ isExpanded: false });
        }
        if (nextProps.focus) {
            this.setState({ isExpanded: true });
        }
    };
    CommentBox.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, publishResult = _a.publishResult, onPublishSuccess = _a.onPublishSuccess, errorMsg = _a.errorMsg, onEditorChanged = _a.onEditorChanged;
        if (publishResult && prevProps.publishResult !== publishResult) {
            onPublishSuccess && onPublishSuccess(publishResult);
        }
        if (errorMsg || publishResult) {
            onEditorChanged({ editorId: this.props.id }); // Clear last result/error
        }
    };
    CommentBox.prototype.render = function () {
        var _a = this.props, user = _a.user, className = _a.className, isLoggedIn = _a.isLoggedIn, canPostComment = _a.canPostComment, commentableItemId = _a.commentableItemId, commentableType = _a.commentableType, isSmall = _a.isSmall, isMobile = _a.isMobile;
        var _b = this.state, loadingState = _b.loadingState, isExpanded = _b.isExpanded;
        var showExpanded = isExpanded || loadingState === 1 /* LOADING */;
        var showSmall = isSmall && !showExpanded;
        return (React.createElement(ElementQueries, { id: this.props.id, className: classnames('no-theme-skin', s['commentbox'], className, showSmall && !showExpanded && 'small-editor', showExpanded && s['expanded']), widthBreakpoints: [490] },
            !isLoggedIn && (React.createElement(React.Fragment, null,
                !isMobile && (React.createElement(UserAvatar, { user: user, size: 32, className: s['commentbox-avatar'], withLink: false })),
                React.createElement("div", { className: classnames(s['commentbox-content'], 'da-editor-comment') },
                    React.createElement(CommentForAnonymous, null)))),
            !canPostComment && isLoggedIn && (React.createElement(DisabledOrPrivateInfo, { commentableItemId: commentableItemId, commentableType: commentableType })),
            canPostComment && isLoggedIn && (React.createElement(React.Fragment, null,
                React.createElement(UserAvatar, { user: user, size: isMobile ? 24 : 32, className: s['commentbox-avatar'], withLink: true }),
                React.createElement("div", { className: classnames(s['commentbox-content'], 'da-editor-comment') }, this.renderInViewEditor())))));
    };
    CommentBox.prototype.renderInViewEditor = function () {
        var _this = this;
        var _a = this.props, tabIndexBase = _a.tabIndexBase, focus = _a.focus, replyComment = _a.replyComment, autoFocus = _a.autoFocus;
        var _b = this.state, focusOnMount = _b.focusOnMount, loadingState = _b.loadingState, isEdit = _b.isEdit;
        // We always want to focus because the lazy placeholder click wants
        // focus right away, but we allow that to be overridden
        var shouldFocus = focus !== false || focusOnMount;
        // Force load the editor on mount when we have content or focus request
        // focus is a little complex here, focus is requested by redux action
        // and then set to false when done, we therefore have to also have some state
        // that forces the mount/load on next render,
        var forceLoadOnMount = Boolean(!!this.initialContent || replyComment || focus || focusOnMount);
        ddt.log('comments', 'CommentBox render focus props: ', {
            focus: focus,
            focusOnMount: focusOnMount,
            autoFocus: autoFocus,
        });
        return (React.createElement(InView, { triggerOnce: true, threshold: 1, onChange: this.onViewChange }, function (_a) {
            var inView = _a.inView, ref = _a.ref;
            return (React.createElement(CommentBoxEditor, { id: _this.props.id, commentableItemId: _this.props.commentableItemId, commentableType: _this.props.commentableType, editorClassName: _this.props.editorClassName, footerClassName: _this.props.footerClassName, "aria-label": _this.props['aria-label'], "aria-labelledby": _this.props['aria-labelledby'], ref: ref, forceLoadOnMount: forceLoadOnMount, initialContent: _this.initialContent || undefined, loadingState: loadingState, tabIndex: (tabIndexBase !== null && tabIndexBase !== void 0 ? tabIndexBase : 0) + 1, autoFocus: autoFocus || (inView && shouldFocus), compact: _this.props.compact, isEdit: isEdit, isReply: Boolean(replyComment), isExpanded: _this.state.isExpanded, onReady: _this.handleEditorReady, onChange: _this.handleEditorChange, onCancel: _this.cancel, onFocus: _this.expand, onSubmit: _this.postComment, onPlaceholderClick: _this.handlePlaceholderClick }));
        }));
    };
    CommentBox.defaultProps = {
        tabIndexBase: 0,
        canPostComment: true,
        onEditorReady: noop,
    };
    return CommentBox;
}(React.PureComponent));
export { CommentBox };
var enhance = compose(withLogBiEvent, withVerification, withTranslation(), withMobileContext);
export default enhance(CommentBox);
//# sourceMappingURL=CommentBox.comment_redesign_b.js.map